exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n\n.header__CardCarcollect-module___3RYYn {\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.iconEditSquare__CardCarcollect-module___3TPLf:hover {\n  color: #0acf97;\n}\n\n@media (max-width: 375px) {\n  .card__CardCarcollect-module___3jusm {\n    min-width: 260px;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"header": "header__CardCarcollect-module___3RYYn",
	"iconEditSquare": "iconEditSquare__CardCarcollect-module___3TPLf",
	"card": "card__CardCarcollect-module___3jusm"
};